module.exports = __webpack_public_path__ + "img/fleche_remonter.6d3a06af.svg";